import { GenericCrudPage } from '@/components/GenericCrudPage';
import { examParticipantsConfig } from '@/pages/configs';

export default function ExamParticipantsPage() {
  return <GenericCrudPage config={examParticipantsConfig} />;
}
